import React from 'react'
import { Alert } from 'reactstrap'

// reactstrap's Alert builds its transition from `Fade.defaultProps`, which Fade no
// longer defines (reactstrap 9.2.3, src/Alert.js:48 vs src/Fade.js). The spread
// therefore yields no timeout and every faded Alert logs
//   "The prop `timeout` is marked as required in `Fade`, but its value is `undefined`"
// even though Fade still falls back to 150ms internally, so the animation is fine.
// Supplying the transition ourselves silences it. Drop this wrapper once reactstrap
// ships a fix; 9.2.3 is the latest release and still has the bug.
const TRANSITION = { timeout: 150, unmountOnExit: true }

export default function FalconAlert({ transition, ...rest }) {
  return <Alert transition={{ ...TRANSITION, ...transition }} {...rest} />
}
